import React from 'react';
import '../styles/Header.css';

const Header = ({ paginaActual }) => {
  return (
    <>
      <div className="header-container">
        <div className="logo-container">
          <img 
            src="/lema-logo-2026-verde.png"
            alt="Logo ICCS" 
            className="logo-image"
          />
        </div>
        
        <h1 className="congress-title">REGISTRO CONGRESO ICCS 2026</h1>
        <h1 className="congress-subtitle">SU PROVIDENCIA - EL ANCLA DE NUESTRA DEPENDENCIA</h1>

        <p className="congress-description">
          Únete a nosotros para un tiempo de renovación espiritual, aprendizaje y comunión con hermanos de diferentes partes del mundo.
        </p>
        
        <div className="event-info">
          <div className="event-info-item">
            <img src="/calendar.png" alt="Calendario" />
            <span>15-17 de Mayo, 2026</span>
          </div>
          <div className="event-info-item">
            <img src="/ubicacion.png" alt="Ubicación" />
            <span>ICCS Sabaneta - Antioquia</span>
          </div>
          <div className="event-info-item">
            <img src="/participantes.png" alt="Participantes" />
            <span>100+ Participantes</span>
          </div>
        </div>
        <br />
        
        {/* Indicador de página */}
        <div className="pagination">
          {[0, 1, 2, 3, 4, 5].map((num) => {
            let isActive = false;
            if (num === 0 && (paginaActual === 1 || paginaActual === 1.5)) {
              isActive = true;
            } else if (num === 1 && paginaActual === 2) {
              isActive = true;
            } else if (num === 2 && paginaActual === 3) {
              isActive = true;
            } else if (num === 3 && paginaActual === 4) {
              isActive = true;
            } else if (num === 4 && paginaActual === 5) {
              isActive = true;
            }
            
            return (
              <div
                key={num}
                className={`pagination-item ${isActive ? 'active' : ''}`}
              >
                {num}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Header;
